export enum CalendarViewType {
  CALENDARS = 'calendars',
  RESOURCES = 'resources',
}

export enum ViewMode {
  TIME_GRID_WEEK = 'timeGridWeek',
  TIME_GRID_DAY = 'timeGridDay',
  DAY_GRID_MONTH = 'dayGridMonth',
  RESOURCE_TIMELINE_WEEK = 'resourceTimelineWeek',
  RESOURCE_TIMELINE_MONTH = 'resourceTimelineMonth',
  RESOURCE_TIME_GRID_DAY = 'resourceTimeGridDay',
}

/** Month views keep a 24h date restore; week/day always open on today. */
export function shouldRestorePersistedDate(viewMode: ViewMode): boolean {
  return (
    viewMode === ViewMode.DAY_GRID_MONTH ||
    viewMode === ViewMode.RESOURCE_TIMELINE_MONTH
  );
}
